import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const SWAGGER_UI_PATH = '/swagger-ui/';

export const swaggerUIRoutesConfig = createRouteConfig(
  {
    swaggerUI: {
      path: SWAGGER_UI_PATH,
      generatePath: () => SWAGGER_UI_PATH,
    },
  },
  SWAGGER_UI_PATH,
);
